import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import AwardeeCard from "./AwardeeCard";
import { Trophy } from "lucide-react";
import { Pagination } from "antd";
import {
  getCurrentMonthList
} from "../../../../redux/corevalueswinner/corevalueswinnerState";



const CurrentMonthWinner = ({
  getCurrentMonthList,
  pagination,
  recordList,
  monthLabel
}) => {

  useEffect(() => {
    getCurrentMonthList();
  }, []);

  return (
    <HeaderComponent
      title={`${monthLabel} Winners`}
      description="This month's outstanding value champions"
      icon={<Trophy className="w-6 h-6 text-white"/>}
      colorTheme="gradient orange !rounded-full"
      descriptionClass="text-sm muted-text"
      cardBorder="border border-amber-200 dark:border-amber-700 bg-gradient-to-br from-white to-amber-50 dark:from-white/10 dark:to-amber-900"
    >
      <div >
        {recordList?.length > 0 ? (
          <AwardeeCard recordList={recordList} />
        ) : (
          <div className="text-center py-12 flex flex-col items-center gap-3 muted-text">
            <h3 className="text-base font-semibold text-gray-700 dark:text-gray-200">
              No winners yet this month
            </h3>

            <p className="text-sm text-gray-500 dark:text-gray-400 max-w-xs">
              Awards will appear here once employees are recognized for this month’s core values.
            </p>
          </div>
        )}
      </div>
      <div className="flex justify-end py-4">
        <Pagination
          current={pagination?.current_page || 1}
          pageSize={pagination?.per_page || 10}
          total={pagination?.total || 0}
          showSizeChanger={false}
          onChange={(page) => {
            getCurrentMonthList({
              page,
              paginate: pagination?.per_page || 10,
            });
          }}
        />
      </div>
   </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.coreValuesWinner.currentMonth?.items,
  pagination: state.coreValuesWinner.currentMonth?.pagination,
  filters: state.coreValuesWinner.currentMonth?.filters,
  requesting: state.coreValuesWinner.currentMonth?.requesting,
  error: state.coreValuesWinner.currentMonth?.error,
  monthLabel: state.coreValuesWinner.currentMonth?.month_label,
});

const mapDispatchToProps = (dispatch) => ({
  getCurrentMonthList: (data) => dispatch(getCurrentMonthList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrentMonthWinner);
